<template>
    <!-- Главный контейнер, который ограничивает границы спиннера -->
    <div style="position: relative">
        <BlockUI :blocked="blocked">
            <div class="form-container px-4">
                <form action="/ereg/timetable" method="post" id="ereg-filter-form" class="ereg-filter-form">
                    <div class="field mb-4">
                        <Dropdown 
                        showClear filter resetFilterOnHide
                        v-model="form.selected_office" 
                        :options="form.office" 
                        optionLabel="name" 
                        placeholder="Адрес филиала" 
                        class="w-full" 
                        @change="(e) => {onSelect(e)}"
                        />
                    </div>
                    <div class="field mb-4">
                        <Dropdown 
                        showClear filter resetFilterOnHide
                        v-model="form.selected_category" 
                        :options="form.category" 
                        optionLabel="name" 
                        placeholder="Отделение" 
                        class="w-full" 
                        @change="(e) => {onSelect(e)}"
                    />
                    </div>
                    <div class="field mb-4">
                        <Dropdown 
                        showClear filter resetFilterOnHide
                        v-model="form.selected_speciality" 
                        :options="form.speciality" 
                        optionLabel="name" 
                        placeholder="Специальность" 
                        class="w-full" 
                        @change="(e) => {onSelect(e)}"
                        />
                    </div>
                    <div class="field mb-4">
                        <Dropdown 
                        showClear filter resetFilterOnHide
                        v-model="form.selected_specialist" 
                        :options="form.specialist" 
                        optionLabel="name" 
                        placeholder="Специалист" 
                        class="w-full" 
                        @change="(e) => {onSelect(e)}"
                        />
                    </div>
                    <div class="field">
                        <Dropdown 
                        showClear filter resetFilterOnHide
                        v-model="form.selected_service" 
                        :options="form.service" 
                        optionLabel="name" 
                        placeholder="Услуга" 
                        class="w-full" 
                        :class="form.selected_service===null ? 'border_warning' : ''"
                        @change="(e) => {onSelect(e)}"
                        name="service"
                        />
                    </div>
                    <div class="mb-4">
                        <div v-if="form.selected_service===null"
                            class="c_f58220 service_attention">
                            * Выберите услугу, чтобы продолжить запись
                        </div>
                    </div>
                    <div class="ereg-btn-wrap">
                        <button 
                            class="btn b_orange like_btn ereg-btn mb-1" 
                            @click="getSchedule"
                            :class="blocked ? 'loading spinner' : ''"
                            :disabled="form.selected_service===null"
                        >Показать расписание</button>
                        <button 
                            @click="() => {refresh(true)}" 
                            class="ml-1 btn b_orange like_btn filter-clear-btn mb-1" 
                        >
                        Очистить фильтр
                        </button>
                    </div>
                    <input type="hidden" name="office" :value="form.selected_office?.id">
                    <input type="hidden" name="category" :value="form.selected_category?.id">
                    <input type="hidden" name="speciality" :value="form.selected_speciality?.id">
                    <input type="hidden" name="specialist" :value="form.selected_specialist?.id">
                    <input type="hidden" name="service" :value="form.selected_service?.id">
                    <input type="hidden" name="action" value="show_schedule" id="hidden_action">
                </form>
            </div>
        </BlockUI>
        <!-- Спиннер находится СНАРУЖИ BlockUI, но внутри relative контейнера -->
        <div v-if="blocked" class="loading-overlay">
            <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="4" />
        </div>
    </div>
</template>

<script>

const URL = process.env.NODE_ENV=="development" ? "http://10.43.232.9/ereg" : window.BASE_URL_ONLY;

import { ref } from 'vue';

const token = ref(document.head.querySelector('meta[name="csrf-token"]'));

const createDefaultForm = () => {
    // 1. Создаем базовый объект формы
    let returnData = {
        office: [],
        selected_office: null,
        category: [],
        selected_category: null,
        specialist: [],
        selected_specialist: null,
        speciality: [],
        selected_speciality: null,
        service: [],
        selected_service: null,
        selected: null
    };

    return returnData;
};

const MAP_HTML_BLOCK = {
    "office": ".js-ereg-office-block",
    "specialist": ".js-ereg-specialist-block",
    "service": ".js-ereg-service-block",
    "timetable": ".wrapper-ereg-section-timetable", 
};

export default {
    name: 'EregForm',
    props: {
    },
    data() {
        return {
            blocked: false,
            form: createDefaultForm()
        };
    },
    methods: {
        findFields(method = "", id = 0) {
            console.log("method = ", method, "id = ", id, this.form["office"]);
            const foundKeys = Object.keys(createDefaultForm()).filter(key => key.includes(method));
            if(foundKeys) {
                // Приводим к числу, на всякий случай
                const searchId = Number(id);
                
                if (!this.form[method] || !this.form[method].length) {
                    return null;
                }
                // Поиск с приведением типов
                const selectedObj = this.form[method].find(obj => Number(obj.id) === searchId);
                console.log("selectedObj 1 = ", selectedObj, this.form[method]);
                this.form["selected_"+method] = null;
                if (selectedObj) {
                    this.form["selected_"+method] = selectedObj;
                    return selectedObj;
                } else {
                    return null;
                }
                
            }

            return null;
        },
        findCategory(id = 0) {
            // Приводим к числу, на всякий случай
            const searchId = Number(id);
            
            if (!this.form.category || !this.form.category.length) {
                console.warn("Массив category пуст или не загружен");
                return;
            }
            
            // Поиск с приведением типов
            const selected_category = this.form.category.find(category => Number(category.id) === searchId);
            this.form.selected_category = null;
            if (selected_category) {
                console.log("Найдена категория:", selected_category);
                this.form.selected_category = selected_category;
                return selected_category;
            } else {
                console.log("Категория с таким id не найден");
                return null;
            }
        },
        findSpecialist(id = 0) {
            // Приводим к числу, на всякий случай
            const searchId = Number(id);
            console.log(`Поиск специалиста с id = ${searchId}`);
            
            if (!this.form.specialist || !this.form.specialist.length) {
                console.warn("Массив specialist пуст или не загружен");
                return;
            }
            
            // Поиск с приведением типов
            const selected_specialist = this.form.specialist.find(specialist => Number(specialist.id) === searchId);
            this.form.selected_specialist = null;
            if (selected_specialist) {
                console.log("Найден специалист:", selected_specialist);
                this.form.selected_specialist = selected_specialist;
                return selected_specialist;
            } else {
                console.log("Специалист с таким id не найден");
                return null;
            }
        },
        onSelect: function (e) {
            const key = e.value ?? {
                code:null
            }; 
            this.form.selected = key.code;
            this.refresh(false);
        },
        async refresh(clear = false) {
            this.blocked = true;
            console.log("clear = ", clear);
            if(clear) {
                this.form = createDefaultForm();
            }
            let form = this.form;

            const body = {
                office: form.selected_office ? form.selected_office.id : null,
                category: form.selected_category ? form.selected_category.id : null,
                speciality: form.selected_speciality ? form.selected_speciality.id : null,
                specialist: form.selected_specialist ? form.selected_specialist.id : null,
                service: form.selected_service ? form.selected_service.id : null,
                selected: form.selected ? form.selected : null,
                action: "show_schedule"
            };

            this.getSchedule();

            try {
                // Обязательно возвращаем (return) сам fetch, чтобы работал .then() наружу
                return await fetch(URL + "/refresh", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-csrf-token': token.value.content,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(body),
                })
                .then(async (response) => {
                    // Избавляемся от вложенного .then внутри json()
                    const list_data = await response.json();
                    console.log("list_data = ", list_data.data);

                    if (typeof(list_data.data) == "object" && list_data.data !== null) {
                        const keys = Object.keys(list_data.data);
                        console.log("keys = ", keys);
                        
                        Object.keys(createDefaultForm()).forEach((el) => {
                            console.log("includes_el = ", el, keys.includes(el));
                            if (keys.includes(el)) {
                                // Заполняем select значениями из справочника
                                this.form[el] = list_data.data[el];
                                // Удалить selected_el, если этого элемента нет в списке
                                const hasItem = list_data.data[el].some(item => item.id === this.form["selected_" + el]);
                                console.log("hasItem = ", hasItem, "selected_" + el);
                            }
                        });
                    }
                    console.log(list_data, typeof(list_data.data));
                    return list_data; // Возвращаем данные для внешнего использования
                });
            } catch (err) {
                console.log("err = ", err);
            } finally {
                this.blocked = false;
            }
        },
        getInfo: async function(formData = new FormData(), action="/") {
            // let html = ""
            const response = await fetch(URL + action, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'x-csrf-token': token.value.content,
                },
                body: formData,
            });
            const data = await response.json();
            return data; 
        },
        async updateBlock(blockName, valueId) {
            document.querySelector(".bord_1_d5")?.classList.add('hidden');
            const form = document.querySelector("#ereg-filter-form");
            if (form) {
                const startElement = form.closest('section');
                
                if (startElement) {
                    let nextEl = startElement.nextElementSibling;
                    
                    // Перебираем все следующие элементы, пока не дойдем до .prefooter_wrap или конца родителя
                    while (nextEl && !nextEl.matches('.prefooter_wrap')) {
                        const elToRemove = nextEl;
                        nextEl = nextEl.nextElementSibling; // Запоминаем следующий элемент до удаления текущего
                        elToRemove.remove();
                    }
                }
            }

            const innerBlock = document.querySelector(MAP_HTML_BLOCK[blockName??""]);
            let innerHTML = "";
            
            const formData = new FormData();
            formData.append('block', blockName);
            formData.append('value', valueId ?? '');
            // formData.append('speciality', this.form.selected_speciality?.id ?? '');

            if(!(valueId ?? false)) {
                innerBlock.classList.add('hidden');
                return false
            }

            try {
                const response = await this.getInfo(formData, "/info");
                
                if (response && response.result === "success") {
                    if (innerBlock) {
                        innerHTML = response.html;
                    }
                    if (innerHTML.trim() === "") {
                        innerBlock.classList.add('hidden');   
                    } else {
                        innerBlock.classList.remove('hidden');
                    }
                }
            } catch (error) {
                console.error(`Ошибка при обновлении блока ${blockName}:`, error);
            } finally {
                innerBlock.innerHTML = innerHTML;
            }
        },
        emptyFunction() {
            
        },
        async getSchedule() {
            const blockName = "timetable"
            const innerBlock = document.querySelector(MAP_HTML_BLOCK[blockName??""]);
            innerBlock.innerHTML = "";
            const form = this.form;
            console.log("getSchedule is run", innerBlock);

            if (form.selected_service && (form.selected_service.id ?? 0) > 0) {
                const formData = new FormData();
                formData.append('office',  this.form.selected_office?.id ?? '');
                formData.append('category', this.form.selected_category?.id ?? '');
                formData.append('speciality',  this.form.selected_speciality?.id ?? '');
                formData.append('specialist', this.form.selected_specialist?.id ?? '');
                formData.append('service', this.form.selected_service?.id ?? '');
                formData.append('action', "show_schedule");

                try {
                    const response = await this.getInfo(formData, "/timetable");
                    if (response && response.result === "success") {
                        if (innerBlock) {
                            innerBlock.innerHTML = response.html;
                            if (typeof window.initSlider === 'function') {
                                window.initSlider();
                            }
                        }
                    } else {
                        if (innerBlock) innerBlock.innerHTML = ""; // Сброс, если сервер вернул ошибку
                    }
                } catch (error) {
                    console.error(`Ошибка при обновлении блока ${blockName}:`, error);
                }
            }
        }
    },

    mounted() {
        this.form = createDefaultForm();
        Object.keys(createDefaultForm()).forEach((el) => {
            if (typeof window !== 'undefined' && window.UPLOAD_FORM_DATA) {
                const hasItem = window.UPLOAD_FORM_DATA[el] ?? false;
                if(hasItem) {
                    this.form["selected_"+el] = { id: window.UPLOAD_FORM_DATA[el]};
                }
            }
        });
        // this.refresh(false)
        this.refresh(false).then(() => {
            Object.keys(createDefaultForm()).forEach((el) => {
                if (typeof window !== 'undefined' && window.UPLOAD_FORM_DATA) {
                    this.findFields(el, window.UPLOAD_FORM_DATA[el]??0);
                }
            });
        });

        console.log("UPLOAD_FORM_DATA");
    },
    watch: {
        // 1. Изменился офис
        'form.selected_office'(newValue, oldValue) {
            if (newValue === oldValue) return;
            // Отправит: block=office & value=ID & speciality=...
            this.updateBlock('office', newValue?.id);
        },

        // 2. Изменился специалист
        'form.selected_specialist'(newValue, oldValue) {
            if (newValue === oldValue) return;
            // Отправит: block=specialist & value=ID & speciality=...
            this.updateBlock('specialist', newValue?.id);
        },

        // 3. Изменилась услуга
        'form.selected_service'(newValue, oldValue) {
            if (newValue === oldValue) return;
            // Отправит: block=service & value=ID & speciality=...
            this.updateBlock('service', newValue?.id);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loading-overlay {
    /* Теперь absolute ищет ближайший родительский relative (наш col-12) */
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    /* Уровень z-index должен быть выше, чем у маски BlockUI (обычно 1100+) */
    z-index: 1001; 
    background: rgba(255, 255, 255, 0.3); /* Легкое дополнительное затемнение */
    border-radius: 6px;
}

/* Убираем лишние стили card, если используем field от PrimeFlex */
.field {
    display: flex;
    justify-content: center;
}

</style>
